import React from 'react';
import cx from 'classnames';
import { TrackedLink, withTracking } from '@xingternal/xing-tracking';
import { trackings } from '@xingternal/platform-layout-trackings';
import { LinkItemPropTypes } from './prop-types';
import styles from './SettingsDropdownList.css';
// tracked wrapper for the links
const SelectListLink = withTracking(trackings)(({ children, href, ...props }) => {
    return (React.createElement(TrackedLink, { trackingKey: "header", to: href, ...props }, children));
});
const LinkItem = ({ link, className, closeModal, intl: { formatMessage }, ...props }) => {
    const { 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    activeIcon, // Just to exclude it from linkProps
    icon: LinkIconElement, title, ...linkProps } = link;
    const linkClasses = cx(className, styles.item);
    const label = formatMessage({ id: title });
    return (React.createElement(SelectListLink, { onClick: closeModal, className: linkClasses, ...linkProps, ...props },
        LinkIconElement && (React.createElement(LinkIconElement, { className: styles.icon, width: 24, height: 24 })),
        React.createElement("span", { className: styles.itemText }, label)));
};
LinkItem.propTypes = LinkItemPropTypes;
export { LinkItem };
//# sourceMappingURL=LinkItem.js.map